import InitialState from "components/toolkit/initial-state.component";
import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import router from "routes";

function App() {
  return (
    <>
      <InitialState />
      <Suspense fallback={<>loading</>}>
        <RouterProvider router={router} />
      </Suspense>

      <ToastContainer />
    </>
  );
}

export default App;
